<template>
  <modal :modal-key="'confirm_challenge_request_rematch'" :class-style="'modal--welcomeback modal--zero-balance'"
         :header-style="'request'"
         :body-style="'request_content'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_confirm_challenge_your_challenge_invitation_for_rematch }}</h1>
      <div class="request_user">
        <img :src=challengeInfo.challengedAvatar alt="">
        <span class="name">{{ challengeInfo.challengedUsername }}</span>
        <span class="level">{{ getTranslations.home_confirm_challenge_level }} {{ challengeInfo.challengedLevel }}</span>
      </div>
    </template>
    <template slot="body">
      <p>{{ getTranslations.home_confirm_challenge_hi }} {{ userDetails.username }} {{
        getTranslations.home_confirm_challenge_ready_to_play }}</p>

      <flickity class="stickers stickers-main" ref="flickity" :options="flickityOptions">
        <div class="stickers-cell">
          <img class="pinicon" :src="'static/images/chat/chat_icon_' + userChoice + '.svg'"
                                        alt=""></div>
      </flickity>

      <flickity class="stickers stickers-nav"
                data-flickity='{ "asNavFor": ".stickers-main", "pageDots": false }'>
        <div class="stickers-cell" v-for="index in 4"
             :key="index"
             :index="index">
          <img class="pinicon" :src="'static/images/chat/chat_icon_' + index + '.svg'" alt=""
               @click.prevent="checkIcon(index)">
        </div>
      </flickity>
    </template>
    <template slot="footer">
      <a style="cursor:pointer" class="btn2 btn2_modal btn2--std btn2--small" @click.prevent="challenge()">{{
        getTranslations.home_confirm_challenge_send_request }}</a>
    </template>
  </modal>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Flickity from 'vue-flickity';
import Modal from '@/components/home/modals/shared/GenericModal';
import RequestForRematch from '@/common/mixins/extraRematchInfo';

export default {
  // modal_confirm_challenge_request.html
  name: 'confirm-challenge-request-rematch',
  data() {
    return {
      userChoice: 1,
      flickityOptions1: {
        asNavFor: '.stickers-main',
        contain: true,
        pageDots: false,
      },
      flickityOptions: {
        draggable: false,
        prevNextButtons: false,
      },
    };
  },
  components: {
    Flickity,
    Modal,
  },
  mixins: [
    RequestForRematch,
  ],
  methods: {
    checkIcon(keyIndex) {
      this.userChoice = keyIndex;
    },
    challenge() {
      this.requestRematch(this.challengeInfo.challengedUsername, true, this.userChoice, false);
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapState('game', [
      'challengeInfo',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/challenge/ConfirmChallengeRequestRematch.vue